import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Automatically unregister any leftover service workers from other projects on this port
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister().then(() => {
        console.log('Unregistered rogue service worker.');
      });
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
